"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var CustomMessage = /** @class */ (function (_super) {
    tslib_1.__extends(CustomMessage, _super);
    function CustomMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomMessage.prototype.render = function () {
        return null;
    };
    return CustomMessage;
}(react_1.PureComponent));
exports.default = CustomMessage;
//# sourceMappingURL=CustomMessage.js.map